(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-related/assets/react/components/button-play.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-related/assets/react/components/button-play.js');

'use strict';

const Button = svs.ui.ReactButton;
const ButtonPlay = () => {
  const buttonLabel = 'Lägg till ännu en lyckoplats';
  const handleClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Relaterat',
      opt_label: buttonLabel
    });
    svs.utils.url.navigate(svs.core.urlMapping.get('lyckoplatsen_Play'));
  };
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-center padding-h-1 padding-bottom-2"
  }, React.createElement(Button, {
    style: {
      maxWidth: '400px'
    },
    onClick: handleClick,
    block: true,
    transparent: true,
    size: 300
  }, buttonLabel));
};
setGlobal('svs.lyckoplatsen.components.page_related.react.components', {
  ButtonPlay
});

 })(window);